<template>
  <el-container>
    <el-header height="54px" style="padding: 0 10px">
      <el-row>
        <el-col :span="18">
          <el-form :inline="true" :model="queryParam">
            <el-form-item label="名称：">
              <el-input v-model="queryParam.SupplierName" style="width: 100px" placeholder="请输入供应商"></el-input>
            </el-form-item>
            <el-form-item label="是否默认：">
              <el-select v-model="queryIsDefault" placeholder="请选择是否默认：" style="width: 125px" clearable>
                <el-option v-for="item in isDefaultOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handleQuery()">查询</el-button>
            </el-form-item>
          </el-form>
        </el-col>
        <el-col :span="6" class="operate" style="float: right">
          <el-button type="primary" plain icon="el-icon-plus" @click="handleSupplierAdd">新增</el-button>
          <el-button type="danger" plain icon="el-icon-delete" @click="handleSupplierDelete(null)">删除</el-button>
        </el-col>
      </el-row>
    </el-header>
    <el-main>
      <grid-table
        ref="gridTable"
        :showIndexColumn="false"
        :showLastEmptyColumn="false"
        :showPagination="true"
        :tableConfig="tableConfig"
        @selectionChange="handleSelectionChange"
        :showCheckboxColumn="true"
        :resizable="false"
      >
        <template slot="OP" slot-scope="{ params }">
          <el-button type="primary" plain size="mini" @click.stop="handleSupplierEdit(params.row)">编辑</el-button>
          <el-button v-if="params.row.IsDefault == 0" plain size="mini" @click.stop="handleDefaulSupplier(params.row)">
            配置默认
          </el-button>
          <el-button type="danger" plain size="mini" @click.stop="handleSupplierDelete(params.row)">删除</el-button>
        </template>
      </grid-table>
    </el-main>
    <el-dialog
      width="500px"
      :title="supplierDialog.title"
      :visible="supplierDialog.visible"
      @close="supplierDialog.visible = false"
      :close-on-click-modal="false"
    >
      <el-form ref="supplierForm" label-width="100px" :model="supplierForm" :rules="editRules">
        <el-form-item label="名称：" prop="supplierName">
          <el-input v-model="supplierForm.supplierName" placeholder="请输入" style="width: 250px" />
        </el-form-item>
        <el-form-item label="QQ：" prop="qq">
          <el-input v-model="supplierForm.qq" placeholder="请输入" style="width: 250px" />
        </el-form-item>
        <el-form-item label="QQ关系：" prop="type">
          <el-select v-model="supplierForm.type" placeholder="请选择" style="width: 250px">
            <el-option v-for="item in qqTypeList" :label="item.label" :value="item.value" :key="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="联系QQ：" prop="botQQ">
          <el-select v-model="supplierForm.botQQ" placeholder="请选择" style="width: 250px">
            <el-option v-for="item in botQQList" :label="item.label" :value="item.value" :key="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="选择市场：" prop="noCustom">
          <el-switch v-model="supplierForm.noCustom"></el-switch>
        </el-form-item>
        <el-form-item label="自定义市场：" prop="market" v-show="!supplierForm.noCustom">
          <el-input v-model="supplierForm.market" placeholder="请输入" style="width: 150px" />
        </el-form-item>
        <el-form-item label="所属市场：" prop="market" v-show="supplierForm.noCustom">
          <el-select v-model="supplierForm.market" placeholder="请选择" style="width: 250px">
            <el-option v-for="item in markets" :label="item.label" :value="item.value" :key="item.value" />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="supplierDialog.visible = false">取 消</el-button>
        <el-button type="primary" v-loading="supplierDialog.loading" @click="handleSaveSupplier()">确 定</el-button>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import { submit } from '@/api/base'

export default {
  name: 'supplierIndex',
  data() {
    return {
      routeParam: {},
      tableConfig: {
        url: '/api/purchase/supplier/getList',
        rowKey: 'SupplierID',
        columns: [
          {
            label: '名称',
            prop: 'SupplierName',
            type: 'text',
          },
          {
            label: 'QQ',
            prop: 'Qq',
            type: 'text',
          },
          {
            label: 'QQ关系',
            prop: 'TypeName',
            type: 'text',
          },
          {
            label: '联系QQ',
            prop: 'BotQQ',
            type: 'text',
          },
          {
            label: '市场信息',
            prop: 'Market',
            type: 'text',
          },
          {
            label: '时间',
            prop: 'ModifyTime',
            type: 'text-datetime',
            dateFormat: 'yyyy-MM-dd',
          },
          {
            label: '是否默认',
            prop: 'IsDefaultName',
            type: 'text',
          },
          {
            label: '操作',
            prop: 'OP',
            type: 'custom-operation',
            width: '300px',
          },
        ],
      },
      supplierDialog: {
        title: '',
        loading: false,
        visible: false,
      },
      supplierForm: {
        supplierID: 0,
        supplierName: '',
      },
      editRules: {
        supplierName: [{ required: true, message: '请输入供应商', trigger: 'blur' }],
      },
      queryParam: {
        SupplierName: '',
        IsDefault: -1,
      },
      queryIsDefault: '',
      detail: {
        loading: false,
        stock: null,
        stockDetails: [],
      },
      exportLoading: false,
      exportOneLoading: false,
      selectRows: [],
      mergeObj: {}, // 用来记录需要合并行的下标
      mergeArr: ['SupplierName'], // 表格中的列名
      markets: [],
      botQQList: [],
      qqTypeList: [
        { label: '好友', value: 'private' },
        { label: '群聊', value: 'group' },
      ],
      isDefaultOptions: [
        { label: '是', value: '1' },
        { label: '否', value: '0' },
      ],
    }
  },
  mounted() {
    this.$nextTick(async () => {
      //this.dateRange = [today, today];
      this.handleQuery()
      this.getMarkets()
      this.getBotQQs()
    })
  },
  methods: {
    reset() {
      this.queryParam.SupplierName = ''
      this.queryIsDefault = ''
      this.queryParam.IsDefault = -1
      this.handleQuery()
    },
    async getMarkets() {
      let { data } = await submit('/api/purchase/supplier/getMarkets')
      this.markets = data
    },
    async getBotQQs() {
      let { data } = await submit('/api/stallBotAccount/getList')
      this.botQQList = []
      data.forEach(item => {
        this.botQQList.push({ label: item.BotName, value: item.BotUid })
      })
    },
    async handleQuery() {
      var that = this
      that.queryParam.IsDefault = that.queryIsDefault == '1' ? 1 : that.queryIsDefault == '0' ? 0 : -1

      that.$refs.gridTable.searchParam = { ...that.queryParam }
      delete that.$refs.gridTable.searchParam.dateRange
      await that.$refs.gridTable.fetchData()
    },
    handleSelectionChange(selection) {
      this.selectRows = selection
      if (selection.length <= 0) {
        this.removeEditData()
      }
    },
    handleSupplierAdd() {
      this.supplierDialog.title = '新增供应商'
      this.supplierForm = {
        supplierID: 0,
        supplierName: '',
        type: 'private',
      }
      this.supplierDialog.visible = true
    },
    handleDefaulSupplier(row) {
      var _this = this
      var confirmText = '确认配置供应商【' + row.SupplierName + '】为默认项？'
      _this.$confirm(confirmText, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        beforeClose: async (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true
            instance.confirmButtonText = '正在提交中...'
            const rsp = await submit('/api/purchase/supplier/SetDefalut', { SupplierID: row['SupplierID'] }).catch(error => {
              instance.confirmButtonLoading = false
              instance.confirmButtonText = '确认'
              done()
            })
            instance.confirmButtonLoading = false
            let msg = rsp.success ? '配置默认供应商成功' : rsp.msg
            _this.$message({ type: rsp.success ? 'success' : 'error', message: msg })
            _this.handleQuery()
            done()
          } else {
            done()
          }
        },
      })
    },
    handleSupplierDelete(row) {
      var _this = this
      var idList = []
      var confirmText = ''
      if (row == null) {
        if (!_this.selectRows || _this.selectRows.length == 0) {
          _this.$baseMessage(`请选择要删除的数据`, 'error')
          return false
        }
        _this.selectRows.forEach(t => {
          idList.push(t['SupplierID'])
        })
        confirmText = '确定要删除选中的 ' + _this.selectRows.length + '个供应商？'
      } else {
        idList.push(row['SupplierID'])
        confirmText = '确定要删除供应商【' + row['SupplierName'] + '】？'
      }
      _this.$confirm(confirmText, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        beforeClose: async (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true
            instance.confirmButtonText = '正在提交中...'
            const rsp = await submit('/api/purchase/supplier/Delete', { SupplierIDs: idList.join(',') }).catch(error => {
              instance.confirmButtonLoading = false
              instance.confirmButtonText = '确认'
              done()
            })
            instance.confirmButtonLoading = false
            let msg = rsp.success ? '删除成功' : rsp.msg
            _this.$message({ type: rsp.success ? 'success' : 'error', message: msg })
            _this.handleQuery()
            done()
          } else {
            done()
          }
        },
      })
    },
    async handleSupplierEdit(row) {
      this.supplierDialog.title = '编辑供应商'

      try {
        const res = await submit('/api/purchase/supplier/GetInfo', {
          SupplierID: row.SupplierID,
          SupplierName: row.SupplierName,
        })
        if (res.success) {
          this.supplierForm = {
            supplierID: res.data.SupplierID,
            supplierName: res.data.SupplierName,
            qq: res.data.ConfigData.qqSetting.qq,
            botQQ: res.data.ConfigData.qqSetting.botQQ,
            type: res.data.ConfigData.qqSetting.type,
            market: res.data.Market,
            noCustom: true,
          }
          if (this.supplierForm.market && !this.markets.some(t => t.value == this.supplierForm.market)) {
            this.supplierForm.noCustom = false
          }
          this.$nextTick(() => {
            this.$refs.supplierForm.clearValidate()
          })
          this.supplierDialog.visible = true
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.log('获取数据失败', error)
      }
    },
    async handleSaveSupplier() {
      var that = this
      that.$refs.supplierForm.validate(async valid => {
        if (valid) {
          let qqSetting = { qq: that.supplierForm.qq, botQQ: that.supplierForm.botQQ, type: that.supplierForm.type }
          that.supplierForm.configData = { qqSetting: qqSetting }
          let editApi = that.supplierForm.supplierID > 0 ? '/api/purchase/supplier/Edit' : '/api/purchase/supplier/Add'
          that.supplierDialog.loading = true
          let rsp = await submit(editApi, that.supplierForm).catch(error => {
            that.supplierDialog.loading = false
          })
          that.supplierDialog.loading = false
          if (!rsp.success) {
            that.$message({ type: 'error', message: rsp.msg })
          } else {
            that.$message({ type: 'success', message: '操作成功!' })
            that.supplierDialog.visible = false
            that.handleQuery()
          }
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.el-header {
  ::v-deep {
    .el-row {
      display: flex;
      align-items: center;
      height: 100%;
    }

    .el-radio-button__inner {
      height: 33px !important;
    }

    .el-form-item {
      margin-bottom: 0 !important;
    }

    .el-input {
      width: 130px !important;
    }

    .el-button {
      height: 33px !important;
    }

    .operate {
      text-align: right;
    }
  }
}
</style>
